import React, { useState } from 'react';
import { Button, Form, Modal } from 'antd';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import { Notification } from '../../../../config/Global';
import Message from '../../../../config/Message';
import FormComponent from './FormComponent';

const AddComponent = observer((props) => {
	const { visible, onClose } = props;
	const [form] = Form.useForm();
	const { ADMINSETTINGS } = useStore();
	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState(false);

	const handleSubmit = (data) => {
		setSaving(true);
		ADMINSETTINGS.addAdminSetting(data)
			.then(() => {
				Notification.success({
					message: Message().CRUD.ADD('User'),
				});
				closeModal();
			})
			.catch((e) => {})
			.finally(() => setSaving(false));
	};

	const handelChange = () => {
		form.validateFields({ validateOnly: true })
			.then(() => {
				setDisabled(false);
			})
			.catch(() => {
				setDisabled(true);
			});
	};

	const closeModal = () => {
		form.resetFields();
		onClose();
	};

	return (
		<Modal
			title="Add Admin Settings"
			onCancel={closeModal}
			open={visible}
			destroyOnClose
			width={'500px'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						disabled={disabled}
						htmlType="submit"
						loading={saving}
						form="AddForm"
					>
						Add Settings
					</Button>
					<Button key={2} onClick={closeModal}>
						Cancel
					</Button>
				</div>
			}
		>
			<FormComponent
				id="AddForm"
				form={form}
				onFinish={handleSubmit}
				handleChange={handelChange}
			/>
		</Modal>
	);
});
export default AddComponent;
